import clsx from "clsx";

export const BlockHeading = (props: { block: { heading?: string; backgroundColor: string } }) => {
    const { block } = props;
    const { heading, backgroundColor } = block;

    const headingClass = ["white", "gray"].includes(backgroundColor) ? "text-secondary" : undefined;

    if (!heading) {
        return null;
    }

    return <h2 className={clsx("h2 text-start", headingClass)}>{heading}</h2>;
};
